import { Button, Form, Input, Spin } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'
import { Detergent, DetergentHistory } from '@/types'
import { GetDetergentHistoryResponse } from '@/types/apis/detergentHistories/GetDetergentHistoryResponse'
import { UpdateDetergentHistoryRequest } from '@/types/apis/detergentHistories/UpdateDetergentHistoryRequest'

import { SpaceCustom } from '../../style'

type Props = {
  detergentId: number
  updateLoading: boolean
  getDetergentHistoryResponse: GetDetergentHistoryResponse | undefined
  getDetergentDetailResponse?: Detergent
  getLoading: boolean
  detergentHistoryData?: { id: number; price: number; quantity: number }
  onSubmit: (formValues: UpdateDetergentHistoryRequest) => void
  onDelete: (id: DetergentHistory['id']) => void
}

const UpdateDetergentHistoryForm = ({
  detergentId,
  updateLoading,
  getLoading,
  getDetergentHistoryResponse,
  getDetergentDetailResponse,
  onSubmit,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [form] = Form.useForm<UpdateDetergentHistoryRequest>()

  useEffect(() => {
    if (getDetergentHistoryResponse && getDetergentDetailResponse) {
      const data = {
        name: getDetergentDetailResponse.name,
      }
      form.setFieldsValue({ ...getDetergentHistoryResponse, ...data })
    }
  }, [getDetergentHistoryResponse, form, getDetergentDetailResponse])

  return (
    <Spin spinning={getLoading}>
      <Form layout="vertical" onFinish={onSubmit} form={form}>
        <Form.Item label={t('components.pages.detergentHistories.update.form.name')} name="name">
          <Input disabled={true} />
        </Form.Item>

        <Form.Item label={t('components.pages.detergentHistories.update.form.price')} name="price">
          <Input
            type="number"
            disabled={true}
            suffix={t('components.pages.detergentHistories.update.form.priceUnit')}
          />
        </Form.Item>

        <Form.Item
          label={t('components.pages.detergentHistories.update.form.quantity')}
          name="quantity"
          rules={[{ required: true, message: t('components.pages.detergentHistories.update.form.requireQuantity') }]}
        >
          <Input type="number" step={1} min={0} suffix={getDetergentDetailResponse?.isWater ? 'm³' : 'ケース'} />
        </Form.Item>

        <Form.Item>
          <SpaceCustom>
            <Button
              onClick={() => {
                const path = routes.detergentHistories.path.replace(':id', detergentId.toString())
                navigate(path)
              }}
            >
              {t('components.pages.detergentHistories.update.form.cancel')}
            </Button>
            <Button type="primary" htmlType="submit" loading={updateLoading}>
              {t('components.pages.detergentHistories.update.form.update')}
            </Button>
          </SpaceCustom>
        </Form.Item>
      </Form>
    </Spin>
  )
}

UpdateDetergentHistoryForm.displayName = 'UpdateDetergentHistoryForm'
export default UpdateDetergentHistoryForm
